import React, { useContext, useState } from 'react';
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import { withTranslation, Trans } from 'react-i18next';
import queryString from 'query-string';

function UserNewPasswordComponent(props) {

  const userContext = useContext(UserContext);
  let params = queryString.parse(location.search)
  const [allValues, setAllValues] = useState({
    confirmPassword: '',
    password: ''
  });

  const changeHandler = e => {
    setAllValues({ ...allValues, [e.target.name]: e.target.value })
  }

  const passwordError = (userContext.errors != null && userContext.errors.password != null);
  const passwordClassName = passwordError ? 'form-control is-invalid' : 'form-control';

  const confirmPasswordError = (userContext.errors != null && userContext.errors.password_confirmation != null);
  const confirmPasswordClassName = confirmPasswordError ? 'form-control is-invalid' : 'form-control';

  const formClassName = userContext.errors != null ? '' : 'was-validated';

  return (
    <ContentCard title={<Trans i18nKey="reset_password" />}>
      <form className={formClassName}
          onSubmit={(event)=> {
            event.preventDefault()
            event.stopPropagation()
            userContext.updatePassword(allValues.password, allValues.confirmPassword, params.reset_password_token)
          }}>
          <div className="">
              <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
              <div className="mb-2">
                  <label htmlFor="password" className="form-label">
                      <Trans i18nKey="password" />*
                  </label>
                  <input
                      type="password"
                      name="password"
                      className={passwordClassName}
                      id="password"
                      value={allValues.password}
                      onChange={changeHandler} />
              </div>
              {passwordError &&
              <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto invalid-feedback">
                  {userContext.errors.password.map((error) => (
                    <span key={error}><Trans i18nKey={error} /></span>
                  ))}
              </div>
              }

              <div className="mb-2">
                  <label htmlFor="confirmPassword" className="form-label">
                      <Trans i18nKey="verify_password" />*
                  </label>
                  <input
                      type="password"
                      name="confirmPassword"
                      className={confirmPasswordClassName}
                      id="confirmPassword"
                      value={allValues.confirmPassword}
                      onChange={changeHandler} />
              </div>
              {confirmPasswordError &&
              <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto invalid-feedback">
                  {userContext.errors.password_confirmation.map((error) => (
                    <span key={error}><Trans i18nKey={error} /></span>
                  ))}
              </div>
              }
          </div>
          <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto">
              <button className="btn btn-primary btn-lg" type="submit">
                  <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="change" />
              </button>
          </div>
      </form>
    </ContentCard>
  );
}

export default withTranslation()(UserNewPasswordComponent);